module.exports = __webpack_public_path__ + "img/banker-purple_460.5aaf515c.png";